import { Button, Row, Col } from "react-bootstrap";
import CartElement from "./CartElement";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../context/cartcontext";

const Cart = () => {
    const {cart, total} = useContext(CartContext);
    return(
        <div className = 'cart'>
            <Row className = 'cartRow'>
                <Col>
                    <h4>Your Cart</h4>
                </Col>
                <Col className = 'text-right'>
                    {
                        cart.length === 0? (
                            <Button disabled variant = 'dark'>Check Out : {total}</Button>
                        ) : (
                            <Button as = {Link} to = '/checkout' variant = 'dark'>Check Out : {total}</Button>
                        )
                    }
                    
                </Col>
            </Row>
            {
                cart.map(element => (
                    <CartElement id = {element.id} />
                ))
            }
        </div>
    );
}

export default Cart;